import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getData } from "../../../backend/api";
import { Button, ButtonSelect, ImgBox, Label, SelectBox, TagBox, TagData, TagItem, TagTitle } from "./styles";
import { DownIcon, TickIcon } from "../../../icons";
import { useTranslation } from "react-i18next";
import { addSelectObject } from "../../../store/actions/select";
import { ErrorMessage } from "../form/styles";
import Search from "../search";
import { getValue } from "../../functions/dataFormat";
import { LabelTop } from "../input/styles";
import { useNavigate } from "react-router-dom";
// import { Variants, Variant } from "../../private/pages/recipe/styles";

function CustomSelect(props) {
  const [optionsVisible, setOptionsVisible] = useState(false);
  const [updateValue, setUpdateValue] = useState({});
  const { i18n } = useTranslation();
  const [selectedLanguage] = useState(i18n.language || "de");
  const [defaultValue] = useState(props.default);
  const [selectedId, setSelectedId] = useState(props.value);
  const [initialized, setInitialized] = useState(false);
  const [selectedValue, setSelectedValue] = useState(props.label);
  const [options, setOptions] = useState([]);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const selectData = useSelector((state) => state.select[props.selectApi]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const toggleOptions = () => {
    setOptionsVisible(!optionsVisible);
  };
  const [searchValue, setSearchValue] = useState("");
  const [searchKey, setSearchKey] = useState("");
  const handleChange = (event) => {
    if (props.apiSearch) {
      fetchData(props.updateValue, true, "", event.target.value.toString());
      setSearchKey(event.target.value);
    } else {
      setSearchValue(event.target.value);
      const filteredOptions = options.filter((option) => {
        if(option.de) {
          return option.de.toLowerCase().includes(event.target.value.toLowerCase()) || option.value.toLowerCase().includes(event.target.value.toLowerCase());
        } else {
          return option.value.toLowerCase().includes(event.target.value.toLowerCase());
        }
      });
      setFilteredOptions(filteredOptions);
      if (event.target.value.toString() === "") {
        setFilteredOptions([]);
      }
    }
    // clearTimeout(searchTimeoutRef.current);
  };
  const { apiType, selectApi, placeHolder, updateOn, listBox, apiSearch, formValues, updateValue: updateValueparam, params } = props;
  const fetchData = useCallback(
    async (item = {}, force = false, name = "", searchKey = "", params = {}) => {
      if (force && apiType === "API") {
        const optionHandler = (data) => {
          setOptions(data);
          setInitialized(true);
          try {
            const option = data.filter((itemValue) => itemValue.id === selectedId)[0].value;
            setSelectedValue(option ? (props?.showItem === "locale" ? option[selectedLanguage] ?? option.value : option.value) : placeHolder);
          } catch {}
        };
        await getData({ ...item, searchKey, limit: apiSearch ? 20 : 0, ...params }, `${selectApi}`, dispatch, navigate)
          .then((response) => {
            if (response.status === 200) {
              optionHandler(response.data);
              dispatch(addSelectObject(response.data, selectApi));
            } else if (response.status === 404) {
              setInitialized(false);
            } else {
              setInitialized(false);
            }
          })
          .catch((error) => {
            setInitialized(false);
          });
      } else if (apiType === "API") {
        const optionHandler = (data) => {
          setOptions(data);
          setInitialized(true);
          try {
            // if (bulkUpload) {
            //   const option = data.filter((itemValue) => itemValue.value === selectedId)[0];
            //   if (!setDefault) {
            //     const value = displayValue ? (showItem === "locale" && selectedLanguage === "de" ? option[selectedLanguage] : option[displayValue]) : showItem === "locale" && selectedLanguage === "de" ? option[selectedLanguage] : option.value;
            //     setSelectedValue(option ? option.value : placeHolder);
            //     console.log({placeHolder,showItem, id: option.id, value: value });
            //     onSelect(index, { id: option.id, value: value }, id, type);
            //     setSetDefault(true);
            //   }
            // } else {
            const option = data.filter((itemValue) => itemValue.id === selectedId)[0];
            setSelectedValue(option ? (props?.showItem === "locale" ? option[selectedLanguage] ?? option.value : option.value) : placeHolder);
            // }
          } catch {}
        };
        if (selectData) {
          optionHandler(selectData);
        } else {
          if (initialized) {
          } else {
            await getData({ ...item }, `${selectApi}`, dispatch, navigate)
              .then((response) => {
                if (response.status === 200) {
                  optionHandler(response.data);
                  dispatch(addSelectObject(response.data, selectApi));
                } else if (response.status === 404) {
                  setInitialized(false);
                } else {
                  setInitialized(false);
                }
              })
              .catch((error) => {
                setInitialized(false);
              });
          }
        }
      } else if (apiType === "CSV") {
        const options = selectApi.split(",").map((item) => {
          return {
            id: item.trim(),
            value: item.trim().charAt(0).toUpperCase() + item.trim().slice(1),
          };
        });
        setOptions(options);
        setInitialized(true);
        try {
          const selected = options.filter((item) => item.id === selectedId)[0].value;
          
          setSelectedValue(selected ? selected : placeHolder);
        } catch {}
      } else if (apiType === "JSON") {
        const options = selectApi;
        setOptions(options);
        setInitialized(true);
        try {
          const selected = options.filter((item) => item.id === selectedId)[0].value;
          setSelectedValue(selected ? selected : placeHolder);
        } catch {}
      }
    },
    [apiType, selectApi, placeHolder, apiSearch, initialized, selectedId, selectData, dispatch]
  );

  useEffect(() => {
    let values = {};
    params?.forEach((item) => {
      values[item.name] = item.value;
    });
    fetchData(values);
  }, [selectApi, params, fetchData]);

  const selectRef = useRef(null);
  useEffect(() => {
    if (updateOn) {
      const isObjectEqual = (obj1, obj2) => {
        const keys1 = Object.keys(obj1 ?? {});
        const keys2 = Object.keys(obj2 ?? {});
        // console.log("Keys:",keys1, keys2);
        if (keys1.length !== keys2.length) {
          return false;
        }

        for (let key of keys1) {
          if (obj1[key] !== obj2[key]) {
            return false;
          }
        }

        return true;
      };
      const equal = isObjectEqual(updateValue, updateValueparam);
      if (!equal) {
        setUpdateValue(updateValueparam);
        let values = {};
        params?.forEach((item) => {
          if (!item.value) {
            item.value = formValues?.[item.name] ?? "";
          }
          values[item.name] = item.value;
        });
        fetchData(updateValueparam, true, updateOn, "", values);
      }
    }
  }, [updateValue, updateValueparam, fetchData, updateOn, params, formValues]);
  useEffect(() => {
    function handleClick(event) {
      if (!selectRef?.current?.contains(event.target)) {
        const listBox1 = listBox ?? false;
        if (!listBox1) {
          setOptionsVisible(false);
        }
        if (listBox1) {
          setOptionsVisible(true);
          setInitialized(true);
        }
      }
    }
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [listBox]);

  return (
    <SelectBox key={props.key} theme={props.theme} className={`custom-select ${props.listBox ? "list-box" : ""} ${optionsVisible ? "open" : "close"} ${props.customClass} ${props.dynamicClass}`} ref={selectRef}>
      <LabelTop>
        {`${t(props.label)}${(props.required && props.label) ? " *" : ""}`}
      </LabelTop>
      <ButtonSelect disabled={props.disabled || false} onClick={toggleOptions}>
        {/* {props.error?.length ? (
          <>
            <Label theme={props.theme} className={`${!props.value?.length > 0 ? "shrink error" : "error"}`}>
              {`${t(props.label)}${props.required ? " *" : ""}`}
            </Label>
          </>
        ) : (
          <>
            <Label theme={props.theme} className={`${!props.value?.length > 0 ? "shrink" : ""}`}>
              <TickIcon />
              {`${t(props.label)}${props.required ? " *" : ""}`}
            </Label>
          </>
        )} */}
        {/* {`${(!props.value || props.value?.length === 0) ? `${props.formType === "put" ? "" : t(props.placeholder)}` : `${t(selectedValue)}`}`} */}
        {`${(!props.value || props.value?.length === 0) ? `${t(props.placeholder)}` : `${t(selectedValue)}`}`}
        {!props.disabled && <DownIcon className="down" />}
      </ButtonSelect>

      <ul className="options">
        {props.search && options.length > 8 && <Search key={`search-inside${props.key}`} className="select" title="Search" theme={props.theme} placeholder={t("search")} value={searchValue} onChange={handleChange} />}
        {props.apiSearch && <Search key="search-api-2" className={"select " + props.customClass} title="Search" theme={props.theme} placeholder={`${t("search")} ${props.label}`} value={searchKey} onChange={handleChange} />}
        {optionsVisible && initialized && (
          <>
            {options.length > 0 &&
              (searchValue.length > 0 ? filteredOptions : options).map((option, index) => (
                <li
                // style={{overflow: 'hidden',lineBreak:"anywhere"}}
                  value={option.id === selectedId}
                  className={option.id === selectedId ? "selected" : ""}
                  key={option.id}
                  onClick={() => {
                    const listBox = props.listBox ?? false;
                    if (!listBox) {
                      toggleOptions();
                      if (selectedId === option.id) {
                        props.onSelect(props.index, { id: defaultValue, value: props.label }, props.id, props.type);
                        setSelectedValue(props.label);
                        setSelectedId(defaultValue);
                      } else {
                        props.onSelect(props.index, option, props.id, props.type, null, option);
                        setSelectedValue(props?.showItem === "locale" ? option[selectedLanguage] : option.value);
                        setSelectedId(option.id);
                      }
                    } else {
                      props.onSelect(props.index, option, props.id, props.type, null, option);
                      setSelectedValue(option.value);
                      setSelectedId(option.id);
                    }
                  }}
                >
                  {props.displayValue ? (props?.showItem === "locale" ? option[selectedLanguage] ?? t(option.value) : option[props.displayValue]) : props?.showItem === "locale" ? option[selectedLanguage] ?? t(option.value) : t(option.value)}
                  {/* {props.displayValue ? option[props.displayValue] : option.value} */}
                  {props.tags && (
                    <TagBox>
                      {props.iconImage && <ImgBox src={process.env.REACT_APP_CDN + (props.iconImage.collection.length > 0 ? option[props.iconImage.collection]?.[props.iconImage.item] ?? "" : option[props.iconImage.item])} />}
                      <TagData>
                        {props.tags.map((tag) => {
                          const titleVlaue = tag.collection.length > 0 ? option[tag.collection]?.[tag.item] ?? "" : option[tag.item] ?? "";
                          let value = "";
                          try {
                            value = getValue(tag, titleVlaue);
                          } catch (error) {
                            console.log(error);
                            value = "";
                          }

                          return (
                            <React.Fragment key={tag.item + index}>
                              <TagTitle>{`${t(tag.title)}`}</TagTitle>
                              <TagItem className={tag?.type?.toString()}>{t(value)}</TagItem>
                            </React.Fragment>
                          );
                        })}
                      </TagData>
                    </TagBox>
                  )}
                  {/* {option.recipeVariants && (
                    <TagBox key={option._id}>
                      {props.iconImage && <ImgBox src={process.env.REACT_APP_CDN + (props.iconImage.collection.length > 0 ? option[props.iconImage.collection]?.[props.iconImage.item] ?? "" : option[props.iconImage.item])} />}
                      <Variants className="noMargin">
                        {option.recipeVariants.map((variant) => (
                          <Variant
                            key={variant._id}
                            onClick={() => {
                              props.selectVariant({ ...variant, recipe: option });
                            }}
                          >
                            <span>
                              <span>BHD</span>
                              <span className="price">{variant.price}</span>
                              <span className="offer">{variant.offerPrice}</span>
                            </span>
                            <span className="variant">{`${variant.variant} / ${variant.calories ?? 0} calories`}</span>
                          </Variant>
                        ))}
                      </Variants>
                    </TagBox>
                  )} */}

                  {props.viewButton && (
                    <Button
                      onClick={() => {
                        props.viewButton?.callback(option);
                      }}
                    >
                      View Menu
                    </Button>
                  )}
                </li>
              ))}
            {initialized && options.length === 0 && (
              <li
                onClick={() => {
                  fetchData(props.updateValue, true, props.updateOn);
                }}
              >
                Refresh
              </li>
            )}
          </>
        )}
      </ul>

      {props.error?.length > 0 && <ErrorMessage dangerouslySetInnerHTML={{ __html: props.error }}></ErrorMessage>}
    </SelectBox>
  );
}

export default CustomSelect;
